import { StringHelpers } from '@salesperformanceint/e4shared';
import { isPast } from '../dates';

export const taskStatuses = {
    Completed: 1,
    AwaitingApproval: 2,
    Outstanding: 3,
    Overdue: 4,
};

export const hasModule = (user, module) => {
    if (!module) return true;
    if (!user) return false;
    const modules = user?.companySettings ? user.companySettings.modules : null;
    return !modules || modules.some(m => m === module);
};

export const coachRoles = {
    view121: { id: '121/View' },
    viewObjectives: { id: 'Objectives/View' },
    viewPathways: { id: 'Pathways/View' },
    viewReviews: { id: 'Reviews/View' },
    manage121: { id: '121/Manage' },
    manageObjectives: { id: 'Objectives/Manage' },
    managePathways: { id: 'Pathways/Manage' },
    manageReviews: { id: 'Reviews/Manage' },
};

export const isCoach = (id, settings, coaching, role) => {
    if (!settings?.development?.allowCoaches || !settings?.development?.coachPermissions.some(x => x === role.id))
        return false;
    const idSafe = parseInt(id, 10);
    return (coaching || []).some(x => x.id === idSafe);
};

export const customText = (property, lower, plural) => {
    //const customTextJson = useSelector(state => state.ui.customText);
    const customTextJson = sessionStorage.getItem('customText');
    if (!customTextJson) return '';
    const customText = JSON.parse(customTextJson);
    let result = customText[property];
    if (!result) return '';
    if (lower) result = result.toLowerCase();
    return plural ? StringHelpers.pluralise(result) : result;
};

export const taskStatus = task => {
    return task.date_Completed
        ? task.requires_Manager && !task.approved
            ? taskStatuses.AwaitingApproval
            : taskStatuses.Completed
        : isPast(task.due)
          ? taskStatuses.Overdue
          : taskStatuses.Outstanding;
};
